/* eslint-disable @typescript-eslint/no-floating-promises */

'use client'

import React from 'react'
import Image from 'next/image'
import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { useModalContext } from '@context/ModalContext/ModalContext'
import { segmentEventCommonPropFunc } from '@utils/segmentProperties'
import assetLoader from '@utils/internalImageLoader'
import styles from './ncolumn.module.scss'

interface NColumnGridCtarops {
  data: {
    id: Number
    name: string
    link: string
    ctaType: string
  }
  withinCard?: boolean
  segmentEventCommonProperties: any
}

const NColumnGridCta: React.FC<NColumnGridCtarops> = ({ data, withinCard, segmentEventCommonProperties }) => {
  const { setShow } = useModalContext()

  if (data && Object.keys(data).length !== 0) {
    const ctaContainerClassName = `${styles.cardCta} ${styles[data?.ctaType]} ${
      withinCard ? styles.ctaWithinCard : styles.ctaOutsideCard
    }`

    const onButtonClick = () => {
      ;(async () => {
        const properties = await segmentEventCommonPropFunc(segmentEventCommonProperties)
        trackEvent('tap_btn_engage', {
          ...properties,
          funnel: 'engage',
        })
      })()

      if (data.link) {
        window.open(data.link, '_blank')
      } else {
        setShow(true)
      }
    }

    return (
      <button
        className={ctaContainerClassName}
        type="button"
        onClick={() => {
          onButtonClick()
        }}>
        <span>{data.name}</span>
        {data?.ctaType && (
          <Image
            src={`${assetLoader()}/images/right-card-cta.svg`}
            alt="Card Right Arrow"
            width={24}
            height={24}
            loading="lazy"
          />
        )}
      </button>
    )
  }
  return null
}

export default NColumnGridCta
